// app/utils/iosCommerce.js
// Apple Guideline 3.1.1 compliance.
// Outside the US storefront, in-app purchase of digital goods/subscriptions must go
// through Apple IAP. For the iOS build we disable in-app commerce entirely:
// organizations subscribe (and individuals purchase) on the JobEng website, and the
// iOS app is a login-and-use companion. This flag + screen enforce that.
//
// IMPORTANT: the CommerceUnavailable screen intentionally does NOT link to or mention
// an external place to pay — outside the US, "steering" users to an external purchase
// is itself a violation. Keep the copy neutral.
//
// DEV NOTE: commerce is left ENABLED in development (__DEV__) so the upgrade/plan
// screens can be reached and tested in the simulator. In production iOS builds the
// gate is still ON, so shipped behavior is unchanged and compliant.
import React from 'react';
import {
  Platform,
  View,
  Text,
  StyleSheet,
  SafeAreaView,
  TouchableOpacity,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
// Single source of truth. Flip logic here if the policy ever changes.
// Production iOS: gated. Development: open, so the upgrade flow is testable.
export const COMMERCE_DISABLED = Platform.OS === 'ios' && !__DEV__;
export function CommerceUnavailable({ navigation, title }) {
  return (
    <SafeAreaView style={styles.safe}>
      <View style={styles.center}>
        <Ionicons name="lock-closed-outline" size={46} color="#9CA3AF" />
        <Text style={styles.title}>{title || 'Not available here'}</Text>
        <Text style={styles.body}>
          Purchases and plan changes aren’t available in the app. Everything included
          with your current plan is ready to use.
        </Text>
        {navigation ? (
          <TouchableOpacity
            style={styles.btn}
            onPress={() => navigation.goBack?.()}
            activeOpacity={0.8}
          >
            <Text style={styles.btnText}>Go back</Text>
          </TouchableOpacity>
        ) : null}
      </View>
    </SafeAreaView>
  );
}
const styles = StyleSheet.create({
  safe: { flex: 1, backgroundColor: '#FFFFFF' },
  center: { flex: 1, alignItems: 'center', justifyContent: 'center', padding: 28 },
  title: {
    fontSize: 20,
    fontWeight: '700',
    color: '#111827',
    marginTop: 16,
    marginBottom: 8,
    textAlign: 'center',
  },
  body: {
    fontSize: 15,
    lineHeight: 22,
    color: '#4B5563',
    textAlign: 'center',
    marginBottom: 24,
  },
  btn: {
    backgroundColor: '#2563EB',
    borderRadius: 12,
    paddingVertical: 14,
    paddingHorizontal: 28,
  },
  btnText: { color: '#FFFFFF', fontSize: 16, fontWeight: '600' },
});
